import { Grid } from '@material-ui/core'
import React from 'react'

import { MainContainer } from '../atoms/MainContainer'
import { TopBar } from '../molecules/TopBar'

interface IProps {
  title: string
}

export const GuestLayout: React.FC<IProps> = ({ title, children }) => (
  <MainContainer>
    <Grid item>
      <TopBar title={title} />
    </Grid>
    <Grid item>{children}</Grid>
  </MainContainer>
)
